export class ApiConfig {
}
